export default __webpack_public_path__ + "static/media/thumb_active-learning.2e6ef29c.webp";